import PropTypes from 'prop-types';
import React from 'react';
import { compose } from 'redux';
import PageTitle from 'hoc/PageTitle';
import PageTheme from 'hoc/PageTheme';
import DashboardTemplate from 'components/templates/Dashboard';
import HeaderContainer from 'containers/HeaderContainer';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import SubSiteRedirectContainer from 'containers/SubSiteRedirectContainer';

const SubSiteRedirect = ({ hostEnvName }) => (
    <DashboardTemplate
        header={<HeaderContainer hideLinks={true} />}
        sidebar={<SideBarContainer navItems={[]} />}
        title={<TitleContainer title={`Please wait, redirecting... ${hostEnvName}`} admin hideDatePicker />}>
        <SubSiteRedirectContainer hostEnvName={hostEnvName} />
    </DashboardTemplate>
);

SubSiteRedirect.propTypes = {
    hostEnvName: PropTypes.string
};

export default compose(
    PageTitle({ pageTitle: 'Redirecting...', showGGBranding: false }),
    PageTheme({ themeDefaults: { 'whitelabel.showGGBranding': false } })
)(SubSiteRedirect);



// WEBPACK FOOTER //
// ./src/components/pages/SubSiteRedirect.js